<span [ngClass]="getCssClassesForDeadline(action)">
    {{ action.date_deadline | date: "mediumDate" }}
</span>
